import { render } from "./ComposeInternal.vue?vue&type=template&id=cb1182fc"
import script from "./ComposeInternal.vue?vue&type=script&lang=js"
export * from "./ComposeInternal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__